import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ICONS as Icons } from "../../data/iconRegistry";
import { api } from "../../lib/api";
import { useLanguage } from "../../contexts/LanguageContext";
import { getNetworkMeta } from "../../data/networksMeta";

export default function NetworksGrid() {
  const [networks, setNetworks] = useState([]);
  const { t, field } = useLanguage();

  useEffect(() => {
    api.get("/networks").then(({ data }) => setNetworks(data)).catch(() => {});
  }, []);

  return (
    <section id="networks" className="py-24 px-4 sm:px-6 lg:px-8" data-testid="networks-grid-section">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-3">{t("home.networks_title", "Nos réseaux sociaux")}</h2>
        <p className="text-zinc-500 mb-12 max-w-xl">{t("home.networks_subtitle", "12 réseaux sociaux, des dizaines de services, un seul endroit.")}</p>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4" data-testid="networks-grid">
          {networks.map((n, i) => {
            const meta = getNetworkMeta(n.slug);
            const Icon = Icons[meta.icon] || Icons.Globe;
            return (
              <motion.div key={n.slug} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 5) * 0.05 }}>
                <Link
                  to={`/reseaux/${n.slug}`}
                  className="group relative block rounded-2xl border border-white/5 bg-zinc-900/60 p-6 overflow-hidden hover:-translate-y-1 transition-transform"
                  data-testid={`network-card-${n.slug}`}
                  style={{ boxShadow: `0 0 0 rgba(0,0,0,0)` }}
                  onMouseEnter={(e) => { e.currentTarget.style.boxShadow = `0 8px 30px ${meta.glow}`; }}
                  onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "none"; }}
                >
                  <div className={`absolute inset-0 opacity-10 bg-gradient-to-br ${meta.gradient}`} />
                  <div className={`relative w-11 h-11 rounded-xl flex items-center justify-center mb-4 bg-gradient-to-br ${meta.gradient}`}>
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <div className="relative font-heading text-sm font-semibold text-white">{field(n, "name")}</div>
                  <div className="relative text-xs text-zinc-500 mt-1 line-clamp-1">{field(n, "tagline")}</div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
